import axios from 'axios';
import dialogInstancePropertyCreator
  from '@/components/global_components/dialogs/global-dialogs/dialogInstancePropertyCreator';
import UncaughtAxiosErrorDialog from '@/components/global_components/dialogs/global-dialogs/UncaughtAxiosErrorDialog';
import WorkAuthentication from "@/services/authentication_services/WorkAuthentication";
import { isNoPermission, showNoPermissionError } from '../middlewares/axios/handler/global-no-permission-handler';
import errorMappingService from '@/services/error-mapping-service';
import store from "@/store";

function handleUnhandledRejection(event) {
  const reason = event.reason;
  if (axios.isAxiosError(reason)) {
    return handleUnhandledAxiosError(reason.response);
  } else {
    return handleAllOtherUnhandledRejections(reason);
  }
}

export default {
  install(Vue) {
    Vue.config.errorHandler = function (err, vm, info) {
      if (axios.isAxiosError(err)) {
        return handleUnhandledAxiosError(err.response);
      }
      window.console.error(err, vm, info);
    }

    window.onerror = function (message, source, lineno, colno, error) {
      window.console.error(message, source, lineno, colno, error);
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);
  },
}

const handleUnhandledAxiosError = (axiosError) => {
  if (!WorkAuthentication.isAuthenticated() || axiosError.config?.url?.endsWith("/configurations/system"))
    return;

  if (isNoPermission(axiosError)) {
    showNoPermissionError();
    return;
  }

  if (axiosError?.isValidationError) {
    const mappedErrors = errorMappingService.extractErrorsForMonitor(axiosError.data?.errors) ?? [];
    store.commit('errorNotificationStore/setErrors', mappedErrors);
    store.dispatch('errorNotificationStore/showErrorNotification');
    return;
  }

  const uncaughtErrorDialog = dialogInstancePropertyCreator(UncaughtAxiosErrorDialog);
  uncaughtErrorDialog.open(axiosError);
}

const handleAllOtherUnhandledRejections = (unhandledError) => {
  window.console.error('REJECTION')
  window.console.error(unhandledError)
}
